const FullPageLoader = () => {
    return (
        <div className="loading">Loading&#8230;</div>
    );
}
export default FullPageLoader;